<template>
    <v-card style="overflow-y: scroll; padding: 0px 30px 0px 30px;" flat>

    <v-overlay :value="loader">
        <v-progress-circular
            indeterminate
            :size="120"
            :width="3"
        ></v-progress-circular>Loading, please wait...
    </v-overlay>

        <template>

            <!-- <v-toolbar flat style="position:fixed !important;  z-index: 1;"> -->
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            fab
                            color="#0d3f57"
                            top
                            right
                            dark
                            absolute
                            fixed
                            elevation="2"
                            style="left:40px;top:75px;"
                            @click="addSystemLogs()"
                            v-show="loggedInUser.id == 1 || loggedInUser.id == 2">
                            <v-icon large>mdi-plus</v-icon>
                        </v-btn>
                    </template>
                <span>Add New Version</span>
                </v-tooltip>
            <!-- </v-toolbar> -->
            <v-divider></v-divider>
            <v-timeline clipped>
                <v-timeline-item
                    v-for="(item, i) in systemLogsData"
                    :key="i"
                    color="red"
                    small>
                <v-card style="padding: 10px; border: 1px solid #0d3f57">
                    <div class="py-2">
                        <v-card class="text-center mb-5" style="background-color: #0d3f57; padding-left: 5px;">
                            <h2 style="color: white; height:43px;line-height:43px;font-family:Arial;" class="d-none d-sm-flex med-pop overline font-weight-bold ml-1">
                            Revision Details
                            <v-spacer></v-spacer>
                            <v-tooltip bottom color="white">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon small class="mr-3 mt-2" v-show="loggedInUser.id == 1 || loggedInUser.id == 2">
                                        <v-icon
                                            color="white"
                                            medium
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="addImage(item)"> mdi-file-image-plus-outline
                                        </v-icon>
                                    </v-btn>

                                </template>
                                <span class="black--text">Add Image</span>
                            </v-tooltip>
                            </h2>
                        </v-card>
                        <span class="sem-bold-pop caption font-weight-bold" style="font-size: 12px; color:# 434b56;">
                            <v-chip outlined color="#0d3f57">
                                <v-icon left>mdi-alpha-v-circle</v-icon>
                                    Version {{ item.version }}
                            </v-chip>
                        </span>
                        <v-card-text 
                            class="pb-n7 mb-n6"
                            role="button" 
                            dense 
                            hide-details
                            v-for="(SUBITEM,ii) in item.imageattachment" :key="ii">

                                <v-icon v-if="item.file_name">
                                    mdi-image-multiple
                                </v-icon>

                            <span @click="getImage(SUBITEM.id)" style="font-family:'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif"> 
                                {{ SUBITEM.file_name }}
                            </span>

                        </v-card-text><br>
                        <v-divider></v-divider>
                        <div class="reg-pop caption text-right mt-3" style="font-size: 13px;">
                            Modification Date : &nbsp;<b>{{ item.modification_date }}</b><br>
                            Deployment Date : &nbsp;<b>{{ item.deployment_date }}</b><br/>
                            Presented Date : &nbsp;<b>{{ item.presented_date }}</b>
                        </div>
                        
                    </div>
                </v-card>
                </v-timeline-item>
            </v-timeline>
        </template>

        <!-- Add New Update Version -->
        <v-dialog v-model="addLogsDialog" persistent width="25%">
            <v-card>
                <v-card-title>
                    <span class="headline"> New Updates </span>
                    <v-spacer/>
                </v-card-title>
                <v-card-text><br>
                    <v-text-field
                        v-model="versionNumber"
                        dense
                        outlined
                        label="Version Number"
                        name="version"
                        style="width:94%;"
                        class="ml-3">
                    </v-text-field>
                    <v-menu
                        v-model="modificationMenu"
                        :close-on-content-click="false"
                        max-width="290px"
                        transition="scale-transition">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="modificationDate"
                            name="modification_date"
                            prepend-inner-icon="mdi-calendar"
                            label="Modification Date"
                            v-bind="attrs"
                            v-on="on"
                            dense
                            outlined
                            color="black"
                            style="width:94%;"
                            class="ml-3">
                        </v-text-field>
                    </template>
                        <v-date-picker 
                            v-model="modificationDate"
                            @input="modificationMenu = false"
                            color="#34495e">
                        </v-date-picker>
                    </v-menu>

                    <v-menu
                        v-model="deploymentMenu"
                        :close-on-content-click="false"
                        max-width="290px"
                        transition="scale-transition">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="deploymentDate"
                            name="deployment_date"
                            prepend-inner-icon="mdi-calendar"
                            label="Deployment Date"
                            v-bind="attrs"
                            v-on="on"
                            dense
                            outlined
                            color="black"
                            style="width:94%;"
                            class="ml-3">
                        </v-text-field>
                    </template>
                        <v-date-picker 
                            v-model="deploymentDate"
                            @input="deploymentMenu = false"
                            color="#34495e">
                        </v-date-picker>
                    </v-menu>

                    <v-menu
                        v-model="presentedMenu"
                        :close-on-content-click="false"
                        max-width="290px"
                        transition="scale-transition">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="presentedDate"
                            name="presented_date"
                            prepend-inner-icon="mdi-calendar"
                            label="Presented Date"
                            v-bind="attrs"
                            v-on="on"
                            dense
                            outlined
                            color="black"
                            style="width:94%;"
                            class="ml-3">
                        </v-text-field>
                    </template>
                        <v-date-picker 
                            v-model="presentedDate"
                            @input="presentedMenu = false"
                            color="#34495e">
                        </v-date-picker>
                    </v-menu>
                    
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark color="success" small @click="saveNewUpdates()"> 保存 </v-btn>
                    <v-btn dark color="red" small @click="closeNewUpdates()"> キャンセル </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- ADD Image for New Update Version -->
        <v-dialog v-model="imageDialog" persistent width="45%">
            <div class="text-center" style="font-family:Sans-serif">
                <center>
                    <v-overlay v-model="overlay">
                        <v-progress-circular
                            indeterminate
                            :size="120"
                            :width="3">
                        </v-progress-circular>Loading,please wait...
                    </v-overlay>
                </center>
            </div>
            
            <v-card>
                <v-card-title style="background: #455a64; color: white">
                    <span class="overline font-weight-black;">Image References</span>
                </v-card-title>
                <v-card-text>
                    <v-file-input
                        v-model="image"
                        class="mt-5 ml-3"
                        prepend-icon=""
                        outlined
                        dense
                        chips
                        multiple
                        clearable
                        density="compact"
                        label="Browse Image"
                        style="width:96%;"
                        @change="fileImage(image)">
                    </v-file-input>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark color="success" small @click="saveImages()"> 保存 </v-btn>
                    <v-btn dark color="red" small @click="closeImages()"> キャンセル </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        

    </v-card>
</template>
<script>
import { mapState,mapActions } from 'vuex';


export default {
    data(){
        return {
            overlay : false,
            attachments : [],
            forSystem : [],
            systemLogsData : [],

            versionNumber : null,
            image : null,
            modificationMenu : false,
            modificationDate : null,
            deploymentMenu : false,
            deploymentDate : null,
            presentedMenu : false,
            presentedDate : null,
            loading : false,
            loader: false,

            // Dialog
            addLogsDialog : false,
            imageDialog : false,
        }
    },

    methods: {
        ...mapActions([
            'cadRequestVer',
        ]),

        getSystemVersions(){
            this.loader = true;
            axios({
                method : "GET",
                url : "api/getSystemVersion"
            }).then(({data}) => {
                this.systemLogsData = data;
                console.log(data)
                this.loader = false;
            })
        },

        addSystemLogs(){
            this.addLogsDialog = true;
        },

        closeSystemLogs(){
            this.addLogsDialog = false;
            this.versionNumber = '',
            this.modificationDate = null,
            this.deploymentDate = null,
            this.presentedDate = null
        },

        addImage(item){
            this.forSystem = {...item}
            console.log(this.forSystem,'forSystem')
            this.imageDialog = true;
        },

        getImage(id){
            window.open(`viewLogsAttachment/${id}`, '_blank');
        },

        // Add New Updates
        saveNewUpdates(){
            
            axios({
                method : "post",
                url : "api/getSystemVersion/store",
                data : {
                    version : this.versionNumber,
                    modification_date : this.modificationDate,
                    deployment_date : this.deploymentDate,
                    presented_date : this.presentedDate
                }
            }).then( (res) => {
                // console.log(res,'res.data')
                this.getSystemVersions();
                this.closeSystemLogs();
                
            })
        },

        closeNewUpdates(){
            this.addLogsDialog = false;
            this.versionNumber = '',
            this.modificationDate = null,
            this.deploymentDate = null,
            this.presentedDate = null

        },

        // Save Images/PDF in New updates
        saveImages(){
            this.overlay = true;
            var formdata = new FormData();
            formdata.append("files", JSON.stringify(this.attachments));
            formdata.append('data', JSON.stringify(this.forSystem))
                axios({
                    method : 'post',
                    url : 'api/update',
                    data : formdata
                }).then( (res) => {
                    // console.log(res.data,'res')
                    this.getSystemVersions();
                    this.imageDialog = false;
                    this.overlay = false;
                })
        },

        closeImages(){
            this.imageDialog = false;
            this.image = null;
        },

        // Add Attachment in New updates
        fileImage(tempVariable){
            this.attachments = [];
                if(tempVariable){
                    tempVariable.forEach(async (item) => {
                        const reader = new FileReader();
                        reader.readAsDataURL(item);
                        reader.onloadend = () => {
                            this.attachments.push({
                                data: reader.result,
                                name: item.name,
                            });
                        };
                    })
                }
            console.log(this.attachments,'attachments')
        }
    },

    mounted() {
        this.getSystemVersions();
    },

    computed: {
        ...mapState([
            'loggedInUser',
            'cadRequestVersion',
        ])
    },
}
</script>
